export enum SYSTEM_ACTIONS {
    'GLOBAL_INITIALIZED',
}
